<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Create User</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Username">
        <b-input v-model="username"></b-input>
      </b-field>
      <b-field label="Password">
        <b-input v-model="password" type="password"></b-input>
      </b-field>
      <b-field label="Confirm Password">
        <b-input v-model="confirmPassword" type="password"></b-input>
      </b-field>
      <b-field>
        <b-checkbox v-model="grantAdmin">Admin</b-checkbox>
      </b-field>
    </section>
    <footer class="modal-card-foot">
      <b-button type="is-info" @click="onClick">Create</b-button>
    </footer>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import $axios from "@/axios-instance";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import ui from "@/store/modules/ui";

export default {
  setup(props, { parent }) {
    const username = ref("");
    const password = ref("");
    const confirmPassword = ref("");
    const grantAdmin = ref(false);

    const onClick = async () => {
      // No empty username
      if (username.value.trim() === "") {
        Snackbar.open({
          message: "Username is empty.",
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
        return;
      }
      // No empty password
      if (password.value.trim() === "") {
        Snackbar.open({
          message: "Password is empty.",
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
        return;
      }
      // Confirm that the 2 passwords are the same
      if (password.value.trim() !== confirmPassword.value.trim()) {
        Snackbar.open({
          message: "Passwords do not match.",
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
        return;
      }
      try {
        // Confirm user
        const answer = window.confirm("Really Create new user ?");
        // Abort if answer is no
        if (!answer) return;
        // Post new user
        await $axios.post("/users", {
          username: username.value.trim(),
          password: password.value.trim(),
          admin: grantAdmin.value
        });
        await ui.fetchUsers();
        parent.close();
      } catch (err) {
        Snackbar.open({
          message: "Username already exists.",
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
      }
    };

    return {
      username,
      password,
      confirmPassword,
      grantAdmin,
      onClick
    };
  }
};
</script>
